
	import { defineComponent } from 'vue'

	import { useDynamicPhoneNumber } from '@/composables/useDynamicPhoneNumber'

	export default defineComponent({
		setup() {
			return useDynamicPhoneNumber('1-877-790-1540')
		},
	})
